import { StyledLeadsPageRoot } from "app/pages/sales-intelligence/common-components/layout";
import FindAppsHeader from "app/pages/sales-intelligence/pages/find-apps/components/FindAppsHeader/FindAppsHeader";
import FindAppsRestrictedEmptyState from "app/pages/sales-intelligence/pages/find-apps/components/FindAppsRestrictedEmptyState/FindAppsRestrictedEmptyState";
import FindAppsContentContainer from "app/pages/sales-intelligence/pages/find-apps/containers/FindAppsContentContainer";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import withSecondaryBarSet from "../../../hoc/withSecondaryBarSet";

const FindAppsPage = () => {
    if (!salesSettingsHelper.isAppsOnly) {
        return <FindAppsRestrictedEmptyState />;
    }

    return (
        <StyledLeadsPageRoot>
            <FindAppsHeader />
            <FindAppsContentContainer />
        </StyledLeadsPageRoot>
    );
};

const FindAppsPageContainer = withSecondaryBarSet("SalesIntelligenceFindApps")(FindAppsPage);

export default FindAppsPageContainer;
